import { render, staticRenderFns } from "./AdminerEdit.vue?vue&type=template&id=54ef2fea&"
import script from "./AdminerEdit.vue?vue&type=script&lang=js&"
export * from "./AdminerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports